"use client";

import Image from "next/image";
import clsx from "clsx";

interface RoundedImageProps {
  src?: string | null;
  alt?: string;
  size?: number;
  width?: number;
  height?: number;
  className?: string;
  fallbackSrc?: string;
  rounded?: number; // px border-radius, 0 = sin redondeo, 9999 para redondeo total
}

const isValidImageUrl = (url: string): boolean => {
  return /\.(jpg|jpeg|png|webp|gif|svg|avif)$/i.test(url.split("?")[0]);
};

export const RoundedImage = ({
  src,
  alt = "Image",
  size,
  width,
  height,
  className,
  fallbackSrc = "/images/icons/profile.png",
  rounded = 9999,
}: RoundedImageProps) => {
  const finalSrc =
    src?.trim() && isValidImageUrl(src.trim()) ? src.trim() : fallbackSrc;

  const useFill = !!className;

  return (
    <div
      className={clsx("relative overflow-hidden", className)}
      style={{ borderRadius: rounded }}
    >
      <Image
        src={finalSrc}
        alt={alt}
        loading="lazy"
        className="object-cover"
        {...(useFill
          ? { fill: true }
          : { width: size ?? width, height: size ?? height })}
      />
    </div>
  );
};
